<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute">
        <img class="box-img" src="../assets/banner3.png" />
        <div class="box-font">办事指南</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px">
      <div style="display: flex; margin-top: 40px">
        <div>
          <leftmenu :value="Category" :list="guide_typelist" @datashow="listshow"></leftmenu>
          <!--登录-->
          <!-- <leftlogin :formData.sync="form"></leftlogin> -->
        </div>
        <div style="margin-left: 20px; width: 100%; border: 1px solid #cccccc">
          <el-table
            :data="this.list"
            height="750"
            style="width: 100%; font-size: 18px; padding-left: 20px"
            :row-style="{}"
            :cell-style="{ 'font-size': '16px', padding: '20px 0px' }"
            :header-row-style="{}"
            :fit="true"
          >
            <el-table-column prop="Title" label="标题" width="750">
              <template slot-scope="scope">
                <router-link
                  :to="'/Guidedetail?id=' + scope.row.Id + '&type=' + scope.row.Category"
                  style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden"
                  >{{ scope.row.Title }}</router-link
                >
              </template>
            </el-table-column>
            <el-table-column prop="CreateTime" label="发布时间" width="190" align="center">
              <template slot-scope="scope">
                {{ scope.row.CreateTime | f_date }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 15, 20]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </article>
  </div>
</template>

<script>
// @ is an alias to /src
import leftmenu from "../components/leftmenu.vue";
import leftlogin from "../components/leftlogin.vue";
export default {
  name: "Guide",
  components: { leftmenu, leftlogin },
  data() {
    return {
      isShow: true,
      list: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      guide_typelist: [],
      Category: "",
      form: {
        name: "",
        pass: "",
        type: "",
      },
    };
  },
  filters: {
    f_date(dateString) {
      // 创建一个新的Date对象
      var date = new Date(dateString);

      // 确保date对象有效
      if (isNaN(date.getTime())) {
        return "Invalid Date";
      }

      // 使用getFullYear, getMonth (注意月份是从0开始的，所以需要+1), getDate方法来获取年、月、日
      // 然后使用字符串拼接来构造新的日期字符串
      var year = date.getFullYear();
      var month = ("0" + (date.getMonth() + 1)).slice(-2); // 保证月份总是两位数
      var day = ("0" + date.getDate()).slice(-2); // 保证日期总是两位数

      // 返回新的日期字符串
      return `${year}-${month}-${day}`;
    },
  },
  created() {
    var that = this;
    that.Category = that.$route.query.id;
    var menulist = JSON.parse(window.localStorage.getItem("menulist")) || [];
    that.guide_typelist = menulist.filter(function (item) {
      return item.Word_Group_Key == "GuideType";
    });
    if (!that.Category) that.getData();
    else {
      var list = that.guide_typelist.filter(function (item) {
        return item.Word_Value == that.Category;
      });
      if (list.length > 0) {
        that.Category = list[0].Word_Value;
        that.getData();
      }
    }
  },
  methods: {
    getData() {
      var that = this;
      var params = {
        PageIndex: that.currentPage,
        PageSize: that.pagesize,
        OrderByFileds: "p.CreateTime desc",
        Category: that.Category,
      };
      that.$api.get("/Guide/Get", params, (r) => {
        that.list = r.response.data;
        that.total = r.response.dataCount;
        that.isShow = false;
      });
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(size) {
      console.log(size, "size");
      this.pagesize = size;
      this.getData();
    },
    handleCurrentChange(currentPage) {
      console.log(currentPage, "currentPage");
      this.currentPage = currentPage;
      this.getData();
    },
    listshow(item) {
      var that = this;
      that.Category = item.Word_Value;
      that.getData();
      return false;
    },
  },
  watch: {
    $route(to) {
      var that = this;
      that.Category = to.query.id;
      var menulist = JSON.parse(window.localStorage.getItem("menulist")) || [];
      that.guide_typelist = menulist.filter(function (item) {
        return item.Word_Group_Key == "GuideType";
      });
      if (!that.Category) that.getData();
      else {
        var list = that.guide_typelist.filter(function (item) {
          return item.Word_Value == that.Category;
        });
        if (list.length > 0) {
          that.Category = list[0].Word_Value;
          that.getData();
        }
      }
    },
  },
  computed: {},
};
</script>

<style>
article.newhome {
  width: 1300px;
}
.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
input::-webkit-input-placeholder {
  color: #999999;
  padding: 10px 0px 16px 10px;
}
.pagination {
  text-align: center;
  margin-top: 10px;
}
.frame-border {
  width: 204px;
  border: 1px solid #eeeeee;
}
.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}
</style>
